// mutations-types
const SET_IS_HEADER_SHOW = "SET_IS_HEADER_SHOW";
const SET_IS_FOOTER_SHOW = "SET_IS_FOOTER_SHOW";

export default {
    namespaced: true,
    state: {
        is_header_show: true,
        is_footer_show: true,
    },
    mutations: {
        [SET_IS_HEADER_SHOW] (state, data) {
            state.is_header_show = data;
        },
        [SET_IS_FOOTER_SHOW] (state, data) {
            state.is_footer_show = data;
        },
    },
    getters: {
        is_header_show (state) {
            return state.is_header_show;
        },
        is_footer_show (state) {
            return state.is_footer_show;
        },
    }
};



// WEBPACK FOOTER //
// ./src/store/modules/layout.js